import Links from '@/shared/constants/navegacao';
import { Column, DataTable } from '@/shared/components/tables/DataTable';
import { Link } from 'react-router-dom';
import { ReadComarcaDto } from '@/api.types';
import { readComarca } from '@/modules/structure/comarca/comarca.service';
import { toast } from 'react-toastify';
import { useDataTableState } from '@/shared/components/tables/useDataTableState';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { useEffect, useState } from 'react';

export default function ComarcaIndexPage() {
  const { setActions } = useBreadcrumbActions();

  const [registros, setRegistros] = useState<[ReadComarcaDto[], number]>();
  const tableState = useDataTableState('nome');

  const handleBuscar = () => {
    readComarca({
      skip: (tableState.currentPage - 1) * tableState.pageSize,
      take: tableState.pageSize,
      comDefensorias: true,
      comNucleos: true,
      comPredios: true,
      orderBy: tableState.sortConfig.direction,
      orderField: tableState.sortConfig.key,
    }).then((result) => {
      setRegistros(result);
    }).catch((res) => {
      toast.error(String(res) || '');
    });
  }

  useEffect(() => {
    handleBuscar();
  }, []);

  useEffect(() => {
    setActions({ primary: { label: 'Cadastrar', href: Links.Comarcas_Criar, onClick: () => { } } });
    return () => setActions({});
  }, [setActions]);

  let colunas: Column<ReadComarcaDto>[] = [
    { key: "ordem", header: "Ordem" },
    { key: "prefixo", header: "Prefixo" },
    { key: "nome", header: "Nome" },
    {
      key: "registros", header: "Unidades / Defensorias / Núcleos",
      render: (row) => {
        return (<>{row.predios?.length} / {row.defensorias?.length} / {row.nucleos?.length}</>)
      }
    },
    {
      key: "agrupar", header: "Agrupada",
      render: (row) => {
        return (<>{<input
          title="Agrupado no relatório"
          type="checkbox"
          checked={row.agrupar}
          readOnly={true}
        ></input>}</>)
      }
    },
    {
      key: "acoes", header: "Ações", render: (row) =>
        <Link className="link-secondary" to={Links.Comarcas_Editar + '/' + row.id}>
          Editar
        </Link>
    },
  ];

  return (
    <div className="row">
      <div className="col-12">
        <h3 className="pt-2">Comarcas</h3>
        <span className="blockquote-footer pb-4 text-end">
          Comarcas do Estado.
        </span>
      </div>
      <hr className="pb-4" />

      {registros &&
        <DataTable
          columns={colunas}
          data={registros[0]}
          initialSortKey='nome'
          onChange={handleBuscar}
          serverSide={true}
          states={tableState}
          totalRecords={registros[1]}
        />
      }
    </div>
  );
}
